// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MnWz","controls":"styles_controls__3BcaI","charLimit":"styles_charLimit__xLR_M","input":"styles_input__3MaQu","send":"styles_send__3USbw"};